module.exports = __webpack_public_path__ + "media/src/img/slick-right-d31f8b1aa4cc85097e570ce0b7e3cc9c.svg";